import React, { useEffect } from 'react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { useConfig } from 'msp-integrations'
import type * as T from './SelectBox.types'
import * as S from './SelectBox.styles'

const SelectBox = ({
  className,
  disabled,
  id,
  label,
  name,
  onBlur,
  onChange,
  onInit,
  options,
  value,
  hasError,
  errorMessage
}: T.SelectBoxProps) => {
  const {
    theme: {
      font: { regular: font }
    }
  } = useConfig()

  useEffect(() => {
    if (!value && options && options.length > 0) {
      onInit && onInit([{ id, value: options[0].id }])
    }
  }, [])

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      const [selectedOption] = options.filter(
        (option) => option.id === event?.target?.value
      )

      onChange(event, selectedOption)
    }
  }

  return (
    <>
      <div
        className={`${
          disabled ? S.SelectBoxWrapperDisabled : S.SelectBoxWrapper
        }`}
      >
        <div className={S.SelectBoxLabelWrapper}>
          <label
            htmlFor={id}
            className={`${
              disabled ? S.SelectBoxLabelDisabled : S.SelectBoxLabel
            }`}
          >
            {label}
          </label>
          <div className={S.SelectBoxLabelBackgroundHelper} />
        </div>
        <select
          id={id}
          name={name}
          className={`${hasError && !disabled && S.SelectBoxErrorBorder} ${
            S.SelectBoxSelect
          } ${className}`}
          disabled={disabled}
          onChange={handleOnChange}
          value={value}
          onBlur={onBlur}
        >
          {(options || []).map((opt: T.SelectOption) => {
            const { id, value, ...restOfProps } = opt
            return (
              <option key={id} value={id} {...restOfProps}>
                {value}
              </option>
            )
          })}
        </select>
        <div className={S.SelectBoxSelectArrow}>
          <ChevronDownIcon
            className='h-5 w-5'
            fill={hasError ? '#c72323' : 'black'}
            stroke='white'
          />
        </div>
      </div>
      {!disabled && hasError && errorMessage && (
        <span className={`text-errorRed ${font}`}>{errorMessage}</span>
      )}
    </>
  )
}

export default SelectBox
